import { takeLatest, call, put, all, select } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, postApi } from 'services/rotasp/api';
import { PATH_IIRGD_API } from 'services/rotasp/path';

// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';
import { CadastrarCidadaoAutistaRequest, Types } from './types';

// ACTIONS
import {
	cadastrarCidadaoAutistaSuccess,
	cadastrarCidadaoAutistaFailure,
} from './actions';

function* cadastrarCidadaoAutista(request: ReducerActionRotaSP) {
	const token: string = yield select(state => state.user.token.data);
	const { payload }: { payload: CadastrarCidadaoAutistaRequest } = request;

	const response: ApiResponse = yield call(
		postApi,
		token,
		PATH_IIRGD_API,
		`cidadao-autista`,
		payload.requestData,
		payload.header,
	);

	if (response.status === 201) {
		yield put(cadastrarCidadaoAutistaSuccess(response));
	} else {
		yield put(cadastrarCidadaoAutistaFailure(response));
	}
}

export default all([
	takeLatest(Types.CADASTRAR_CIDADAO_AUTISTA_REQUEST, cadastrarCidadaoAutista),
]);
